import React from "react";
import { Formik, Form as FormikForm } from "formik";
import { Button, Card } from "react-bootstrap";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { ordersApi } from "../api/services";
import { getErrorMessage } from "../api/client";
import FormField from "../components/forms/FormField";
import OrderDetailsPanel from "../components/OrderDetailsPanel";
import Seo from "../components/Seo";
import { PAGE_SEO } from "../constants/seo";
import "./OrderTracking.css";

const schema = Yup.object({
  orderNumber: Yup.string().trim().required("Order number is required"),
  email: Yup.string().trim().email("Enter a valid email").nullable(),
});

const OrderTracking = () => {
  const params = new URLSearchParams(window.location.search);
  const presetOrder = params.get("order") || "";

  return (
    <main className="track-page">
      <Seo {...PAGE_SEO.orderTracking} />
      <section className="track-hero">
        <span className="track-badge">Orders</span>
        <h1>Order Tracking</h1>
        <p>Enter your order number to check status and delivery progress.</p>
      </section>

      <section className="track-section">
        <Formik
          enableReinitialize
          initialValues={{ orderNumber: presetOrder, email: "" }}
          validationSchema={schema}
          onSubmit={async (values, { setSubmitting, setStatus }) => {
            try {
              const res = await ordersApi.track({
                orderNumber: values.orderNumber.trim(),
                email: values.email || undefined,
              });
              setStatus(res.data.data.order);
              toast.success("Order found");
            } catch (error) {
              setStatus(null);
              toast.error(getErrorMessage(error, "Order not found"));
            } finally {
              setSubmitting(false);
            }
          }}
        >
          {({ isSubmitting, status }) => (
            <>
              <FormikForm className="track-form" noValidate>
                <FormField
                  name="orderNumber"
                  label="Order number"
                  placeholder="SG-20260727-1234"
                />
                <FormField
                  name="email"
                  type="email"
                  label="Email (optional)"
                  placeholder="Used at checkout"
                />
                <Button type="submit" className="track-btn" disabled={isSubmitting}>
                  {isSubmitting ? "Searching..." : "Track order"}
                </Button>
              </FormikForm>

              {status && (
                <Card className="track-result">
                  <Card.Body>
                    <h3>{status.orderNumber}</h3>
                    <p>
                      Status: <strong>{status.status}</strong>
                    </p>
                    <p>
                      Placed:{" "}
                      {status.createdAt
                        ? new Date(status.createdAt).toLocaleString()
                        : "—"}
                    </p>
                    <p>Total: AED {Number(status.total).toFixed(2)}</p>
                    <OrderDetailsPanel order={status} />
                  </Card.Body>
                </Card>
              )}
            </>
          )}
        </Formik>
      </section>
    </main>
  );
};

export default OrderTracking;
